import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

interface MediaPlaceholderProps {
  icon: LucideIcon;
  children: ReactNode;
}

export function MediaPlaceholder({ icon: Icon, children }: MediaPlaceholderProps) {
  return (
    <div className="flex aspect-4/3 w-full flex-col items-center justify-center gap-2 rounded-lg border border-dashed bg-muted/30 text-xs text-muted-foreground">
      <Icon className="size-6" aria-hidden />
      {children}
    </div>
  );
}
